// Tags: the tags the product's type gives it (the names and keywords of it and the groups above it — read-only,
// they follow the tree; the type is picked in the Type tab) and the vendor's own tags, saved with the product.
// The search finds the product by all of them.
import React, { useEffect, useState } from "react"
import { LockClosedIcon } from "@heroicons/react/24/outline"
import { Field, errorMessage } from "../../../AdminShared/ui"
import { ProductTypeInfo } from "../../../AdminShared/api"
import TagsEditor from "../../../AdminShared/product-types/TagsEditor"
import { LANGUAGES } from "../../../AdminShared/product-types/useProductTypes"
import usePortalTexts from "../../../Vendor/texts/usePortalTexts"
import { PRODUCTS } from "../../../Vendor/texts/bundles"
import HelpHint from "aldoo-ra/HelpCenter/InPlaceHelp"

const chip = "inline-flex items-center gap-1 h-7 px-2.5 rounded-full text-xs"

export default function TagsTab({ editor }) {
  const t = usePortalTexts(PRODUCTS)
  const { pid, read, set } = editor
  const [info, setInfo] = useState(null)
  const [language, setLanguage] = useState("bg")
  const tags = Array.isArray(read("tags")) ? read("tags") : []

  useEffect(() => {
    if (!pid) return
    ProductTypeInfo(pid).then((res) => !errorMessage(res) && setInfo(res))
  }, [pid])

  const typeTags = info?.typeTags?.[language] || []

  return (
    <div className="flex flex-col gap-5 max-w-[760px]" data-testid="tags-tab">
      {/* the type's own words: read-only, they follow the tree */}
      <Field label={t`Tags from the product type`} hint={t`They come from the product type and change with it — they cannot be edited here.`}>
        <div className="flex items-center gap-2 mb-1">
          {LANGUAGES.map((code) => (
            <button key={code} type="button" onClick={() => setLanguage(code)} className={`px-2 h-6 rounded-full text-[11px] font-semibold uppercase ${language === code ? "bg-admin_primary text-white" : "border border-admin_bordered text-admin_text_secondary"}`}>
              {code}
            </button>
          ))}
        </div>
        <div className="flex flex-wrap gap-1.5" data-testid="tags-type-tags">
          {!typeTags.length && <span className="text-sm text-admin_text_secondary italic">—</span>}
          {typeTags.map((tag) => (
            <span key={tag} className={`${chip} bg-admin_neutral_1 text-admin_text_secondary`} title={t`From the product type`}>
              <LockClosedIcon className="w-3 h-3" />
              {tag}
            </span>
          ))}
        </div>
      </Field>

      {/* the vendor's own */}
      <Field label={<span className="inline-flex items-center gap-1.5">{t`Your tags`}<HelpHint helpKey="vendor.product.setup#tags" /></span>} hint={t`Words buyers may search your product by: a brand, a material, a flavour, an occasion. Press Enter to add.`}>
        <TagsEditor value={tags} onChange={(next) => set("tags", next)} productType={info?.productType || ""} t={t} />
      </Field>
    </div>
  )
}
